import { createFileRoute } from "@tanstack/react-router";
import { SpokePage, buildSpokeHead, type SpokePageConfig } from "@/components/SpokePage";

const CONFIG: SpokePageConfig = {
  slug: "real-estate-broker-property-manager-marketing-colorado",
  metaTitle: "Real Estate Broker & Property Manager Marketing in Colorado",
  metaDescription: "Marketing for Colorado real estate brokers and property managers: websites from $1,850, local SEO and Google Maps from $950/month, month-to-month.",
  breadcrumbs: [{ label: "Home", to: "/" }],
  currentLabel: "Broker & Property Manager Marketing",
  eyebrow: "Real Estate Brokers & Property Managers — Colorado",
  h1: (
    <>
      Real Estate Broker & <span className="text-brand-gold">Property Manager</span> Marketing in Colorado
    </>
  ),
  heroDescription: "Get more owner, seller and buyer leads from your own website and Google Maps.",
  intro: "Owners looking for a property manager and sellers looking for a broker start on Google. We build your website, neighborhood pages and Google Maps profile so you own those leads, from Colorado Springs and Fountain to Castle Rock, Denver and Fort Collins.",
  definition: { term: "Broker and property manager marketing", body: "Bringing in seller, buyer and rental-owner leads through your own website, local search, Google Maps and AI tools." },
  whatWeDo: [
    { title: "Lead-ready website", body: "Clear pages for sellers, buyers and rental owners." },
    { title: "Neighborhood pages", body: "Local guides for the areas you serve." },
    { title: "Owner pages", body: "Property management services, fees and FAQs." },
    { title: "Google Maps", body: "Reviews, photos and posts that build trust." },
    { title: "AI search", body: "Plain answers AI tools can recommend." },
    { title: "Clear pricing", body: "Websites from $1,850. Marketing from $950/mo." },
  ],
  whyThisMarket: [
    { heading: "Your own leads", body: "Leads from your own website are yours to keep." },
    { heading: "Military moves", body: "Fort Carson, Peterson and the Air Force Academy keep Springs rentals busy." },
    { heading: "Trust matters", body: "Owners hand you their biggest asset; reviews and clear answers win them." },
  ],
  relatedLinks: [
    { to: "/pricing", label: "Pricing" },
    { to: "/free-mockup", label: "Get a free website mockup" },
    { to: "/free-audit", label: "Get a free marketing audit" },
    { to: "/colorado-springs-headquarters", label: "Colorado Springs headquarters" },
    { to: "/web-design-castle-rock-colorado", label: "Castle Rock web design company" },
    { to: "/case-studies", label: "Colorado case studies" },
  ],
  faqs: [
    { q: "How much does it cost?", a: "Websites are $1,850 (Starter), $2,750 (Pro) or $5,950 (Expert), one-time, with one year of hosting and SSL. Monthly marketing is $950, $1,650 or $2,750 per month. Edits and repairs are $250/hour." },
    { q: "Do I have to sign a long contract?", a: "No. Monthly marketing is month-to-month." },
    { q: "Where are you located?", a: "Our office is at 3210 E Woodmen Rd STE 110, Colorado Springs, CO 80920. We serve businesses across Colorado." },
    { q: "How fast can my website be ready?", a: "Most websites are ready in under 7 business days." },
  ],
  serviceName: "Real Estate Broker and Property Manager Marketing in Colorado",
  serviceDescription: "Marketing for Colorado real estate brokers and property managers: websites from $1,850, local SEO and Google Maps from $950/month, month-to-month.",
  areaServed: "Colorado",
};

export const Route = createFileRoute("/real-estate-broker-property-manager-marketing-colorado")({
  head: () => buildSpokeHead(CONFIG),
  component: () => <SpokePage config={CONFIG} />,
});
